import { connect } from "react-redux";
import { PageTermsOfUse } from "senac-components";
import {
  PageTermsOfUseDispatchProps,
  PageTermsOfUseStateProps,
  PageTermsOfUseProps,
} from "senac-components/dist/pages/Mobile/PageTermsOfUse";
import { PageTermsOfUseWeb } from "senac-components/dist/pages/Web/PageTermsOfUse";
import { AppDispatch, RootState } from "../store";
import { commonSlice, userSlice } from "../store/reducers";
import { PageHeaderOptionItem } from "senac-components/dist/pages/Mobile/PageInterfaces";

const mapState = (state: RootState) => {
  const authenticatedUser = state.userState.user != undefined;
  let result: PageTermsOfUseStateProps = {
    authenticatedUser: true,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageTermsOfUseDispatchProps = {
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) =>
      dispatch(commonSlice.actions.goToMyProfileOption(option)),
    onSelectedNavigationPageOption: (option) =>
      dispatch(commonSlice.actions.goToPage(option)),
  };

  return result;
};

const WPageTermsOfUse = () => {
  const Mobile = connect(mapState, mapDispatch)(PageTermsOfUse);
  const Web = connect(mapState)(PageTermsOfUseWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageTermsOfUse };
